import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { useT } from '../i18n';

export default function ScrollToTop() {
  const { t } = useT();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      className="xp-scroll-top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label={t('Scroll to top')}
      data-testid="scroll-to-top"
    >
      <ArrowUp style={{ width: 16, height: 16 }} />
    </button>
  );
}
